import { useEffect, useRef, useState } from "react";

const useScale = (
  targetWidth: number,
  targetHeight: number,
  hoverScale = 1.1
) => {
  const elementRef = useRef<HTMLElement>(null);
  const [isHovered, setIsHovered] = useState(false);

  useEffect(() => {
    const scaleElement = () => {
      const element = elementRef.current;

      if (element) {
        const originalWidth = element.offsetWidth;
        const originalHeight = element.offsetHeight;

        const scaleWidth = targetWidth / originalWidth;
        const scaleHeight = targetHeight / originalHeight;

        const scale =
          Math.min(scaleWidth, scaleHeight) * (isHovered ? hoverScale : 1);

        element.style.transform = `scale(${scale})`;
      }
    };

    scaleElement();
  }, [targetWidth, targetHeight, hoverScale, isHovered]);

  return {
    ref: elementRef,
    onMouseEnter: () => setIsHovered(true),
    onMouseLeave: () => setIsHovered(false),
  };
};

export default useScale;
